module.exports = __webpack_public_path__ + "static/media/horizon.90473917.png";